export default __webpack_public_path__ + "90c045b7547db9275807d46d2be475e7.ttf";